import React from 'react';
import './Navbar.scss';
import logo from './../../assets/logo.png';
import {NavLink} from 'react-router-dom';

const Navbar = () => {

    const navbarItems = [
        {
            name: 'Home',
            path: '/',
        },
        {
            name: 'Dental Plans',
            path: '/singleservice',
        },
        {
            name: 'About Us',
            path: '/about',
        },
        {
            name: 'Blog',
            path: '/blogs-faq',
        }
    ];

    return (
        <div className='main-nav'>
            <div className="container">
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid">
                        {/* Logo */}
                        <NavLink className="navbar-brand" to="/">
                            <div className="logo-container">
                                <img src={logo} alt="logo" />
                                <div className="logo-text">
                                    <span className="brand-name">TRUECARE</span>
                                    <span className="brand-subtitle">DENTAL & IMPLANT CENTER</span>
                                </div>
                            </div>
                        </NavLink>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            {/* Navbar Link */}
                            <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                               { 
                                navbarItems.map (navSingle =>
                                    <li className="nav-item" key={navSingle.path}>
                                        <NavLink 
                                            className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                                            to={navSingle.path}
                                            end={navSingle.path === '/'}
                                        >
                                            {navSingle.name}
                                        </NavLink>
                                    </li>
                                    ) 
                                }
                            </ul>
                            
                            {/* Navbar Button */}
                            <div className="phone-call-btn">
                                <a href="tel:6395947006" className="call-button">
                                    <div className="call-icon">📞</div>
                                    <div className="call-text">
                                        <span className="call-label">Call</span>
                                        <span className="phone-number">6395947006</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Navbar;